import moment from 'moment';
const dateFormat = 'YYYY/MM/DD';
const WIDTH = 100;


const headerDateFormat = (date) => {
  const startDateMoment = moment(date.startDate, dateFormat);
  const endDateMoment = moment(date.endDate, dateFormat);
  return `${startDateMoment.format('D')} - ${endDateMoment.format('D')} ${startDateMoment.format('MMMM')}`;
};

const createHeader = (dates = [], firstLine = true) => {
  const header = dates.map((date) => ({
    'className': 'data-frame',
    'readOnly': true,
    'value': firstLine ? 'TOTAL' : headerDateFormat(date),
    'width': WIDTH,
  }));
  header.push({
    'className': 'data-frame',
    'readOnly': true,
    'value': firstLine ? '' : 'TOTAL',
    'width': WIDTH,
  });
  return header;
};


// eslint-disable-next-line
const sumWeekTotal = (element, dates = [], agencies = [], lastRow = false) => {
  const totalWeek = [];
  const lenDates = dates.length + 1;
  dates.forEach((data, idx) => {
    let acu = 0;
    let pivotToMove = idx + 1; // dates == 4 works like a pivotToMove to move 1 + 5 + 9
    agencies.forEach((agency, idx) => {
      if (idx >= 1) {
        pivotToMove = pivotToMove + lenDates;
      }
      const validateElement = typeof(element[pivotToMove]) !==
      'undefined' ? element[pivotToMove].value : 0;
      acu = +acu + +validateElement;
    });
    totalWeek.push({
      'className': lastRow ? 'data-frame' : '',
      'readOnly': true,
      'value': acu,
      'width': WIDTH,
    });
  });
  totalWeek.push({
    'className': lastRow ? 'data-frame' : '',
    'readOnly': true,
    'value': totalWeek.reduce((acc, el) => acc + el.value, 0),
    'width': WIDTH,
  });
  return totalWeek;
};

export const addTotalCols = (dates = [], data = [], agency = []) => {
  const newData = [];
  if (dates.length >= 1 && agency && data && data[0].length >= 2) {
    const firstLine = createHeader(dates);
    const secondLine = createHeader(dates, false);
    data.forEach((element, idx) => {
      if (idx === 0) {
        newData.push([...element, ...firstLine]);
      } else if (idx === 1) {
        newData.push([...element, ...secondLine]);
      } else {
        const validateLastRow = (idx + 1) === data.length;
        const sumTotalsArr = sumWeekTotal(element, dates, agency, validateLastRow);
        newData.push([...element, ...sumTotalsArr]);
      }
    });
  }
  return newData;
};

